<app-breadcrumb></app-breadcrumb>

<div class="page-loading-shade" *ngIf="isProcessing">
  <app-custom-spinner *ngIf="isProcessing"></app-custom-spinner>
</div>

<div class="position-relative grid-content" style="margin-top: 10px;">
  <div>
    <div class="d-flex justify-content-between">
      <div class="d-flex align-items-center px-3">
        <div class="dropdown">
        </div>
      </div>
      <div class="d-flex gap-3">
        <div id="header-container">
          <div class="">
            <div class="search-container">
              <span class="fa fa-search form-control-feedback"></span>
              <input type="text" class="form-control search_input" style="font-size: 12px" placeholder="Search here..."
                [(ngModel)]="searchValue" />
            </div>
          </div>
        </div>
        <div class="addIconContiner d-flex gap-2 justify-content-center align-items-center" (keydown.enter)="openAddPopup()" (click)="openAddPopup()">
          <img src="../../../assets/img/cr_module/add_new.svg" width="18px" height="18px" alt="add new" />
          <span class="reload_text text-white">Add New</span>
        </div>
        <div class="addIconContiner d-flex gap-2 justify-content-center align-items-center"
          (click)="openReport('Excel')" (keydown.enter)="openReport('Excel')">
          <i class="fa fa-file-excel-o" style="font-size:18px;color:white"></i>
          <span class="reload_text text-white">Excel Report</span>
        </div>
        <div class="addIconContiner d-flex gap-2 justify-content-center align-items-center" (keydown.enter)="openReport('Pdf')" (click)="openReport('Pdf')">
          <i class="fa fa-file-pdf-o" style="font-size:18px;color:white"></i>
          <span class="reload_text text-white">PDF Report</span>
        </div>
        <div class="addIconContiner d-flex gap-2 justify-content-center align-items-center"
          *ngIf="message.isAuditTrailUser" (keydown.enter)="openAuditTrail('overAll',0)" (click)="openAuditTrail('overAll',0)">
          <i class="fa-solid fa-clipboard" style="font-size:18px;color:white"></i>
          <span class="reload_text text-white">Audit Trail</span>
        </div>
        <div class="reloadIconContiner d-flex gap-2 justify-content-center align-items-center"
          (click)="refreshGridData()" (keydown.enter)="refreshGridData()">
          <img src="../../../assets/img/cr_module/reload.svg" width="18px" height="18px" alt="reload" />
          <span class="reload_text">Reload</span>
        </div>
      </div>
    </div>
  </div>

  <div class="table-container">
    <table class="dynamic-table-container" style="max-height: 60vh;">
      <thead>
        <th style="min-width: 60px; text-align: center;">
          <div style="display: flex;">
            <div>
              <i id="parent-menu-icons" class="fa-solid fa-ellipsis-vertical"></i>
            </div>
          </div>
        </th>

        <th class="grid-header-container"
          [ngStyle]="{'min-width': '100px','max-width': '300px','overflow': 'hidden','text-overflow': 'ellipsis','white-space': 'nowrap'}">
          <div class="thheader d-flex justify-content-between align-items-center gap-3 px-2 py-2">
            <span>Template Name</span>
            <div class="d-flex gap-2 align-items-center">
              <div (click)="sortColumn('Template Name',certificateTemplateData)"
              (keydown.enter)="sortColumn('Template Name',certificateTemplateData)">
                <img src="../../../assets/img/qms_img/sort.svg" width="9px" height="16px" alt="sort" />
              </div> 
            </div>
          </div>
          <div class="row-search-container">
            <input type="text" class="form-control" placeholder="Search"
              (input)="columnSearch('templateName', $event,'string')" />
          </div>
        </th>

        <th class="grid-header-container"
          [ngStyle]="{'min-width': '100px','max-width': '350px','overflow': 'hidden','text-overflow': 'ellipsis','white-space': 'nowrap'}">
          <div class="thheader d-flex justify-content-between align-items-center gap-3 px-2 py-2">
            <span>Template</span>
            <div class="d-flex gap-2 align-items-center">
              <div (click)="sortColumn('Template',certificateTemplateData)" (keydown.enter)="sortColumn('Template',certificateTemplateData)">
                <img src="../../../assets/img/qms_img/sort.svg" width="9px" height="16px" alt="sort" />
              </div> 
            </div>
          </div>
          <div class="row-search-container">
            <input type="text" class="form-control" placeholder="Search" />
          </div>
        </th>

        <th class="grid-header-container"
          [ngStyle]="{'min-width': '100px','max-width': '250px','overflow': 'hidden','text-overflow': 'ellipsis','white-space': 'nowrap'}">
          <div class="thheader d-flex justify-content-between align-items-center gap-3 px-2 py-2">
            <span>Is Default With Score Template?</span>
            <div class="d-flex gap-2 align-items-center">
              <div (keydown.enter)="sortColumn('Is Default With Score Template?',certificateTemplateData)"(click)="sortColumn('Is Default With Score Template?',certificateTemplateData)">
                <img src="../../../assets/img/qms_img/sort.svg" width="9px" height="16px" alt="sort" />
              </div> 
            </div>
          </div>
          <div class="row-search-container">
            <input type="text" class="form-control" placeholder="Search"
              (input)="columnSearch('isDefaultWithscoreTemplate', $event,'string')" />
          </div>
        </th>

        <th class="grid-header-container"
          [ngStyle]="{'min-width': '100px','max-width': '250px','overflow': 'hidden','text-overflow': 'ellipsis','white-space': 'nowrap'}">
          <div class="thheader d-flex justify-content-between align-items-center gap-3 px-2 py-2">
            <span>Is Default Without Score Template?</span>
            <div class="d-flex gap-2 align-items-center">
              <div (keydown.enter)="sortColumn('Is Default Without Score Template?',certificateTemplateData)"(click)="sortColumn('Is Default Without Score Template?',certificateTemplateData)">
                <img src="../../../assets/img/qms_img/sort.svg" width="9px" height="16px" alt="sort" />
              </div> 
            </div>
          </div>
          <div class="row-search-container">
            <input type="text" class="form-control" placeholder="Search"
              (input)="columnSearch('isDefaultWithoutscoreTemplate', $event,'string')" />
          </div>
        </th>

        <th class="grid-header-container"
          [ngStyle]="{'min-width': '140px','max-width': '200px','overflow': 'hidden','text-overflow': 'ellipsis','white-space': 'nowrap'}">
          <div class="thheader d-flex justify-content-between align-items-center gap-3 px-2 py-2">
            <span>Created On</span>
            <div class="d-flex gap-2 align-items-center">
              <div (keydown.enter)="sortColumn('Created On',certificateTemplateData)" (click)="sortColumn('Created On',certificateTemplateData)">
                <img src="../../../assets/img/qms_img/sort.svg" width="9px" height="16px" alt="sort" />
              </div> 
            </div>
          </div>
          <div class="row-search-container">
            <input type="text" class="form-control" placeholder="Search"
              (input)="columnSearch('createdOn', $event,'date')" />
          </div>
        </th>

        <th class="grid-header-container"
          [ngStyle]="{'min-width': '140px','max-width': '200px','overflow': 'hidden','text-overflow': 'ellipsis','white-space': 'nowrap'}">
          <div class="thheader d-flex justify-content-between align-items-center gap-3 px-2 py-2">
            <span>Created By</span>
            <div class="d-flex gap-2 align-items-center">
              <div (click)="sortColumn('Created By',certificateTemplateData)" (keydown.enter)="sortColumn('Created By',certificateTemplateData)">
                <img src="../../../assets/img/qms_img/sort.svg" width="9px" height="16px" alt="sort" />
              </div> 
            </div>
          </div>
          <div class="row-search-container">
            <input type="text" class="form-control" placeholder="Search"
              (input)="columnSearch('createdByUser', $event,'string')" />
          </div>
        </th>

        <th class="grid-header-container"
          [ngStyle]="{'min-width': '140px','max-width': '200px','overflow': 'hidden','text-overflow': 'ellipsis','white-space': 'nowrap'}">
          <div class="thheader d-flex justify-content-between align-items-center gap-3 px-2 py-2">
            <span>Updated On</span>
            <div class="d-flex gap-2 align-items-center">
              <div (keydown.enter)="sortColumn('Updated On',certificateTemplateData)"(click)="sortColumn('Updated On',certificateTemplateData)">
                <img src="../../../assets/img/qms_img/sort.svg" width="9px" height="16px" alt="sort" />
              </div> 
            </div>
          </div>
          <div class="row-search-container">
            <input type="text" class="form-control" placeholder="Search"
              (input)="columnSearch('updatedOn', $event,'date')" />
          </div>
        </th>

        <th class="grid-header-container"
          [ngStyle]="{'min-width': '140px','max-width': '200px','overflow': 'hidden','text-overflow': 'ellipsis','white-space': 'nowrap'}">
          <div class="thheader d-flex justify-content-between align-items-center gap-3 px-2 py-2">
            <span>Updated By</span>
            <div class="d-flex gap-2 align-items-center">
              <div (click)="sortColumn('Updated By',certificateTemplateData)" (keydown.enter)="sortColumn('Updated By',certificateTemplateData)">
                <img src="../../../assets/img/qms_img/sort.svg" width="9px" height="16px" alt="sort" />
              </div> 
            </div>
          </div>
          <div class="row-search-container">
            <input type="text" class="form-control" placeholder="Search"
              (input)="columnSearch('updatedByUser', $event,'string')" />
          </div>
        </th>
         <th class="grid-header-container"
          [ngStyle]="{'min-width': '140px','max-width': '200px','overflow': 'hidden','text-overflow': 'ellipsis','white-space': 'nowrap'}">
          <div class="thheader d-flex justify-content-between align-items-center gap-3 px-2 py-2">
            <span>Reason Update</span>
            <div class="d-flex gap-2 align-items-center">
              <div (click)="sortColumn('Reason Update',certificateTemplateData)" (keydown.enter)="sortColumn('Reason Update',certificateTemplateData)">
                <img src="../../../assets/img/qms_img/sort.svg" width="9px" height="16px" alt="sort" />
              </div> 
            </div>
          </div>
          <div class="row-search-container">
            <input type="text" class="form-control" placeholder="Search"
              (input)="columnSearch('update Reason', $event,'string')" />
          </div>
        </th>

        <th id="menu" class="sticky-col first-col"></th>
      </thead>
      <tbody>
        <tr *ngFor="let list of pagedItems let idx = index;" [class.highlightRow]="list.childCheckBox == true">

          <td style="min-width: 60px; text-align: center;">
            <div style="display: flex;">
              <div [ngClass]="list.childCheckBox ?'static_icon':'hover-menu-icons'">
                <i class="fa-solid fa-ellipsis-vertical"></i>
              </div>
              <div>
                <input type="checkbox" style="zoom: 1.2;" [checked]="list.childCheckBox"
                  (change)="dataGridChildCheckBoxChecked($event, list, idx)">
              </div>
            </div>
          </td>

          <td  class="sticky-dynamic-row1"
            [ngStyle]="{'min-width':'100px','max-width': '300px','overflow': 'hidden','text-overflow': 'ellipsis','white-space': 'nowrap'}">
            {{list.templateName}}
          </td>

          <td  class="sticky-dynamic-row1"
            [ngStyle]="{'min-width':'100px','max-width': '350px','overflow': 'hidden', 'text-overflow': 'ellipsis', 'white-space': 'nowrap'}">
            <div class="download-button-continer btn-align" mat-dialog-actions>
              <button class="d-flex align-items-center" mat-stroked-button class="downloadButton"
                (click)="previewTemplate(list.template)">
                <img src="../../../assets/img/cr_module/download.svg" width="12px" height="12px" alt="download">
                <span class="ms-1">View</span>
              </button>
            </div>
          </td>

          <td  class="sticky-dynamic-row1"
            [ngStyle]="{'min-width':'100px','max-width': '200px','overflow': 'hidden', 'text-overflow': 'ellipsis', 'white-space': 'nowrap'}">
            <span>
              <div class="gridCheckBoxes">
                <img *ngIf="list.isDefaultWithscoreTemplate == 'Y'" src="../../../assets/img/accessSymbol.svg"
                  width="20" height="20" alt="Yes">
                <img *ngIf="list.isDefaultWithscoreTemplate != 'Y'" src="../../../assets/img/noAcessSymbol.svg"
                  width="20" height="20" alt="No">
              </div>
            </span>
          </td>

          <td  class="sticky-dynamic-row1"
            [ngStyle]="{'min-width':'100px','max-width': '200px','overflow': 'hidden', 'text-overflow': 'ellipsis', 'white-space': 'nowrap'}">
            <span>
              <div class="gridCheckBoxes">
                <img *ngIf="list.isDefaultWithoutscoreTemplate == 'Y'" src="../../../assets/img/accessSymbol.svg"
                  width="20" height="20" alt="Yes">
                <img *ngIf="list.isDefaultWithoutscoreTemplate != 'Y'" src="../../../assets/img/noAcessSymbol.svg"
                  width="20" height="20" alt="No">
              </div>
            </span>
          </td>

          <td  class="sticky-dynamic-row1"
            [ngStyle]="{'min-width':'140px','max-width': '200px','overflow': 'hidden','text-overflow': 'ellipsis','white-space': 'nowrap'}">
            {{list.createdOn | date:'dd-MMM-yyyy HH:mm:ss'}}
          </td>
          <td  class="sticky-dynamic-row1"
            [ngStyle]="{'min-width':'140px','max-width': '200px','overflow': 'hidden','text-overflow': 'ellipsis','white-space': 'nowrap'}">
            {{list.createdByUser}}
          </td>
          <td  class="sticky-dynamic-row1"
            [ngStyle]="{'min-width':'140px','max-width': '200px','overflow': 'hidden','text-overflow': 'ellipsis','white-space': 'nowrap'}">
            {{list.updatedOn | date:'dd-MMM-yyyy HH:mm:ss'}}
          </td>
          <td  class="sticky-dynamic-row1"
            [ngStyle]="{'min-width':'140px','max-width': '200px','overflow': 'hidden','text-overflow': 'ellipsis','white-space': 'nowrap'}">
            {{list.updatedByUser}}
          </td>
          <td  class="sticky-dynamic-row1"
            [ngStyle]="{'min-width':'140px','max-width': '200px','overflow': 'hidden','text-overflow': 'ellipsis','white-space': 'nowrap'}">
            {{list.updateReason}}
          </td>

          <td class="sticky-col first-col">
            <div class="action-icons">
              <i class="fa-solid fa-pencil" matTooltip="Edit" style="margin-left: 5px;"
                (click)="openEditPopup(list, true)" (keydown.enter)="openEditPopup(list, true)"></i>
              <i class="fa-sharp fa-solid fa-trash" matTooltip="Delete" style="margin-left: 5px;"
                (click)="openDeletePopup(list)" (keydown.enter)="openDeletePopup(list)"></i>
              <img *ngIf="message.isAuditTrailUser" matTooltip="Audit Trail" alt="Trail" width="20" height="20"
                src="../../assets/img/trail-individual.svg" (keydown.enter)="openAuditTrail('individual',list)" (click)="openAuditTrail('individual',list)" />
            </div>
          </td>
        </tr>
      </tbody>
    </table>
  </div>
  <div class="d-flex justify-content-center">
    <div class="width-cheat small paginationCell">
      <div class="d-flex align-items-center gap-3">
        <div class="pagination_text mt-3">
          {{ showingRowsText }}
          1-{{ perPage }} of {{ collectionSize | number }}
        </div>
        <div>
          <ngb-pagination class="leftpadding" (pageChange)="setPage(pager.currentPage, $event)" [disabled]="false"
            [collectionSize]="pager.totalItems" [(page)]="pager.currentPage" [maxSize]="maxSize" [rotate]="true"
            [pageSize]="perPage" [ellipses]="false" [boundaryLinks]="true" size="sm">
          </ngb-pagination>
        </div>
        <div ngbDropdown class="mt-3">
          <button class="btn btn-primary btn-sm mr-1 bg-white pagination_text" id="dropdownBasic1" ngbDropdownToggle>
            {{ perPage }}
            <i class="ms-1 fa-solid fa-chevron-down"></i>
          </button>
          <div ngbDropdownMenu aria-labelledby="dropdownBasic1">
            <button ngbDropdownItem (click)="paginationCall(10)">10</button>
            <button ngbDropdownItem (click)="paginationCall(20)">20</button>
            <button ngbDropdownItem (click)="paginationCall(50)">50</button>
          </div>
          per page
        </div>
      </div>
    </div>
  </div>
</div>

<ng-template #addAndEditPopup>
  <div class="ng-template-container">
    <div class="page-loading-shade" *ngIf="isProcessing">
      <app-custom-spinner *ngIf="isProcessing"></app-custom-spinner>
    </div>
    <button class="close close-button" (click)="cancelAddAndEditFunction()" mat-button><i
        class="fa popupClose">&#xf00d;</i></button>
    <div mat-dialog-title>
      <label for="title" class="popupTitle"> {{ popupDataTitle.title }}</label>
      <label for="app-name" class="popupAppTitle">One<span style="color:gold;">QMS</span> </label>
    </div>
    <div class="form-continer"  style="max-height: 552px !important;">
      <div class="row">
        <div class="col-md-6">
          <div><label for="email" id="template-name">Template Name</label><span class="mandatory-symbol">*</span></div>
          <input class="input-filed-continers uppercase" type="text" [(ngModel)]="certificateTemplateData.templateName"
            (ngModelChange)="onNgModelChange($event,'template-name')">
        </div>
        <div class="col-md-3">
          <div><label for="email">Is Default With Score</label></div>
          <mat-slide-toggle color="primary" [(ngModel)]="certificateTemplateData.isDefaultWithscoreTemplate1">
            <span class="active-inActive-container" *ngIf="certificateTemplateData.isDefaultWithscoreTemplate1==true"
              [ngStyle]="certificateTemplateData.isDefaultWithscoreTemplate1==true?{'color':'green'} : {'color': ''}">Yes</span>
            <span *ngIf="certificateTemplateData.isDefaultWithscoreTemplate1==false"
              [ngStyle]="certificateTemplateData.isDefaultWithscoreTemplate1==false?{'color':'red'} : {'color': ''}">No</span>
          </mat-slide-toggle>
        </div>
        <div class="col-md-3">
          <div><label for="email">Is Default Without Score?</label></div>
          <mat-slide-toggle color="primary" [(ngModel)]="certificateTemplateData.isDefaultWithoutscoreTemplate1">
            <span class="active-inActive-container" *ngIf="certificateTemplateData.isDefaultWithoutscoreTemplate1==true"
              [ngStyle]="certificateTemplateData.isDefaultWithoutscoreTemplate1==true?{'color':'green'} : {'color': ''}">Yes</span>
            <span *ngIf="certificateTemplateData.isDefaultWithoutscoreTemplate1==false"
              [ngStyle]="certificateTemplateData.isDefaultWithoutscoreTemplate1==false?{'color':'red'} : {'color': ''}">No</span>
          </mat-slide-toggle>
        </div>
      </div>
      <br>
      <div class="row">
        <div class="col-md-12">
          <div><label for="email" id="template">Template</label><span class="mandatory-symbol">*</span>
            <i class="fa fa-eye" style="margin-left: 1%;" title="Preview"
              (click)="previewTemplate(certificateTemplateData.template)" (keydown.enter)="previewTemplate(certificateTemplateData.template)"></i>
            <i class="fas fa-exclamation-circle" (click)="clickToGetNote()" (keydown.enter)="clickToGetNote()" title="Reference Tags"
              style="margin-left: 1%;cursor: pointer;color: green;"></i>
          </div>
          <textarea type="text" rows="15" [(ngModel)]="certificateTemplateData.template"
            (ngModelChange)="onNgModelChange($event,'template')" class="textarea-filed-continers"></textarea>
        </div>
      </div>
      <div class="row">
        <div class="col-md-6" *ngIf="visibleEditButton">
          <div><label for="email" id="update-reason">Reason for Update</label><span class="mandatory-symbol">*</span>
          </div>
          <textarea type="text" class="input-filed-textarea" rows="3" cols="50"
            [(ngModel)]="certificateTemplateData.updateReason"
            (ngModelChange)="onNgModelChange($event,'update-reason')"></textarea>
        </div>
      </div>
    </div>
  </div>
  <div class="d-flex justify-content-end gap-3 mx-3 button-continer" mat-dialog-actions>
    <div class="addIconContiner d-flex gap-2 justify-content-center align-items-center"
      (click)="addAndEditFunction(certificateTemplateData)" (keydown.enter)="addAndEditFunction(certificateTemplateData)" *ngIf="visibleAddButton">
      <img src="../../../assets/img/cr_module/add_new.svg" width="18px" height="18px" alt="add new" />
      <span class="reload_text text-white">Add New</span>
    </div>
    <div class="addIconContiner d-flex gap-2 justify-content-center align-items-center"
      (click)="addAndEditFunction(certificateTemplateData)" (keydown.enter)="addAndEditFunction(certificateTemplateData)" *ngIf="visibleEditButton">
      <i class="fas fa-user-edit" style="font-size: 18px;color: white;"></i>
      <span class="reload_text text-white">Update</span>
    </div>
    <button mat-stroked-button class="cancelButton" (click)="cancelAddAndEditFunction()">
      <i class="fa fa-close"></i> Cancel
    </button>
  </div>
</ng-template>

<ng-template #deletePopup>
  <div class="page-loading-shade" *ngIf="isProcessing">
    <app-custom-spinner *ngIf="isProcessing"></app-custom-spinner>
  </div>
  <button class="close close-button" (click)="cancelDeleteFunction()" mat-button><i
      class="fa popupClose">&#xf00d;</i></button>
  <div mat-dialog-title>
    <label for="title" class="popupTitle"> {{ popupDataTitle.title }}</label>
  </div>
  <div style="margin: 15px 15px;">
    <div>
      <div class="row">
        <div class="col-md-12">
          <div>
            <label id="delete-reason-validation" for="email">Reason for Delete</label>
            <span class="mandatory-symbol">*</span>
          </div>
          <textarea type="text" class="input-filed-textarea" rows="4" cols="50"
            [(ngModel)]="certificateTemplateData.deleteReason"
            (ngModelChange)="onNgModelChange(certificateTemplateData.deleteReason, 'delete-reason-validation')"></textarea>
        </div>
      </div>
    </div>
    <div class="d-flex justify-content-end gap-3 mx-3 button-continer" mat-dialog-actions>
      <div class="addIconContiner d-flex gap-2 justify-content-center align-items-center"
        (click)="deleteFunction(certificateTemplateData)" (keydown.enter)="deleteFunction(certificateTemplateData)">
        <i class="fa fa-trash" style="font-size: 18px;color: white;"></i>
        <span class="reload_text text-white">Delete</span>
      </div>
      <button mat-stroked-button class="cancelButton" (click)="cancelDeleteFunction()">
        <i class="fa fa-close"></i> Cancel
      </button>
    </div>
  </div>
</ng-template>

<ng-template #previewPopup>
  <button class="close close-button" (click)="cancelPreviewFunction()" mat-button><i
      class="fa popupClose">&#xf00d;</i></button>
  <div mat-dialog-title>
    <label for="title" class="popupTitle">Template</label>
    <label for="app-name" class="popupAppTitle">One<span style="color:gold;">QMS</span> </label>
  </div>
  <div class="ng-template-container" style="background-color: #f9f7f2;">
    <div [innerHTML]="previewData"></div>
  </div>
</ng-template>
<ng-template #notePopup>
  <div class="page-loading-shade" *ngIf="isProcessing">
    <app-custom-spinner *ngIf="isProcessing"></app-custom-spinner>
  </div>
  <button class="close close-button" (click)="cancelNote()" mat-button><i class="fa popupClose">&#xf00d;</i></button>
  <div mat-dialog-title>
    <label for="title" class="popupTitle">Reference Tags</label>
    <label for="app-name" class="popupAppTitle">One<span style="color:gold;">QMS</span> </label>
  </div>
  <div style="margin: 15px 15px;">
    <div class="row">
      <div class="col-md-12">
        &amp;lt;ORG_LOGO&amp;gt;<br>
        &amp;lt;ORG_NAME&amp;gt;<br>
        &amp;lt;PERCENTAGE&amp;gt;<br>
        &amp;lt;TRAINING_NAME&amp;gt;<br>
        &amp;lt;TRAINING_TYPE&amp;gt;<br>
        &amp;lt;COMPLETED_ON&amp;gt;<br>
        &amp;lt;USER_FIRST_NAME&amp;gt;<br>
        &amp;lt;USER_LAST_NAME&amp;gt;<br>
        &amp;lt;REASON_FOR_SIGN&amp;gt;<br>
        &amp;lt;USER_DESIGNATION&amp;gt;<br>

      </div>
    </div>
  </div>
</ng-template>

<ng-template #angularEditor>
  <div class="page-loading-shade" *ngIf="isProcessing">
    <app-custom-spinner *ngIf="isProcessing"></app-custom-spinner>
  </div>
  <button class="close close-button" (click)="cancelAngularEditor()" mat-button><i
      class="fa popupClose">&#xf00d;</i></button>
  <div mat-dialog-title>
    <label for="title" class="popupTitle"> {{editorTitle}} </label>
    <label for="app-name" class="popupAppTitle">One<span style="color:gold;">QMS</span> </label>
  </div>
  <br>
  <div class="row">
    <div class="col-md-12 st-editor">
      <st-editor [(ngModel)]="editorNgModel" [config]="disabled" [spellcheck]="true"></st-editor>
    </div>
  </div>
  <div class="button-continer btn-align" mat-dialog-actions>
    <button mat-stroked-button class="cancelButton" (click)="cancelAngularEditor()">
      <i class="fa fa-close"></i> Cancel
    </button>
  </div>
</ng-template>

<app-static-audit-trail #auditTrailPopup></app-static-audit-trail>
<app-excel-pdf #excelPdfPopup [excelPdf]="excelPdf"></app-excel-pdf>